<template>
  <v-dialog
    v-model="dialog"
    persistent
    v-on:click:outside="onCancel()"
    :max-width="maxWidth"
  >
    <v-card :class="{ [cardClass]: true }">
      <v-card-title class="headline" v-if="headText">
        {{ headText }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3" v-if="contentText || $slots.default">
        {{ contentText }}
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel()" :loading="loading" v-if="cancelButton">
          <v-icon class="mr-2" v-if="cancelButton.icon">{{
            cancelButton.icon
          }}</v-icon>
          {{ cancelButton.text || $t("dialogs.close") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="onConfirm()"
          :loading="loading"
          v-if="!withOutConfirm"
        >
          <v-icon class="mr-2" v-if="confirmButton.icon">{{
            confirmButton.icon
          }}</v-icon>
          {{ confirmButton.text || $t("dialogs.ok") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommonDialog",
  props: {
    cardClass: {
      type: String
    },
    dialog: {
      type: Boolean,
      default: false
    },
    onConfirm: {
      type: Function,
      default: new Function()
    },
    onCancel: {
      type: Function,
      default: new Function()
    },
    headText: {
      type: String
    },
    contentText: {
      type: String
    },
    confirmButton: {
      type: Object,
      default: function() {
        return {
          icon: "mdi-check"
        };
      }
    },
    cancelButton: {
      type: Object,
      default: function() {
        return {
          icon: "mdi-close"
        };
      }
    },
    withOutConfirm: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      default: "600px"
    }
  },
  computed: {}
};
</script>

<style scoped></style>
